import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { useIgnoreExtensionErrors } from './hooks/useIgnoreExtensionErrors';
export function App() {
  useIgnoreExtensionErrors();
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23vunsb2v8su3">
      <MetaPixel data-id="element-1" data-mp="23utby4e102bb" />
      <CountdownBar data-id="element-2" data-mp="23t8iki3g6pf1" />
      <main data-id="element-3" data-mp="3ijxokogyjwiu">
        <Hero data-id="element-4" data-mp="3ikh8ubu2yx01" />
        <StatsBar data-id="element-5" data-mp="3ikqwvtvkeu33" />
        <Difference data-id="element-6" data-mp="3ij61k21ff746" />
        <Recognize data-id="element-7" data-mp="3ihv2gfixenje" />
        <WhatsInside data-id="element-8" data-mp="3mlj8gtrwtb2j" />
        <LookInside data-id="element-9" data-mp="3ml17xky7saot" />
        <InstantAccess data-id="element-10" data-mp="3mk8710lxsfel" />
        <Bonuses data-id="element-11" data-mp="3mjq45l4rr2xp" />
        <Offer data-id="element-12" data-mp="3mj6jhwnqi0fz" />
        <Guarantee data-id="element-13" data-mp="3rcj7c4kla37o" />
        <Testimonials data-id="element-14" data-mp="3rbzngibdp4r0" />
        <Faq data-id="element-15" data-mp="3rcsyhvhdegey" />
      </main>
      <Footer data-id="element-16" data-mp="3reltuemj9e7n" />
    </div>;
}